module.exports = __webpack_public_path__ + "tables/media/total-sale.1983cf5b.svg";